<template>
  <v-container>
    <v-card>
      <v-card-title>
        <v-icon left>shield</v-icon>
        Módulo de Auditoría
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="12" sm="3">
            <v-select
              v-model="filtros.modelo"
              :items="modelosOpciones"
              item-text="text"
              item-value="value"
              label="Modelo"
              prepend-icon="mdi-table"
              clearable
              outlined
              dense
              @change="consultar"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="3">
            <v-select
              v-model="filtros.evento"
              :items="eventosOpciones"
              item-text="text"
              item-value="value"
              label="Evento"
              prepend-icon="mdi-flash"
              clearable
              outlined
              dense
              @change="consultar"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="3">
            <v-autocomplete
              v-model="filtros.usuario_id"
              :items="usuarios"
              item-text="name"
              item-value="id"
              label="Usuario"
              prepend-icon="mdi-account"
              clearable
              outlined
              dense
              @change="consultar"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
              v-model="filtros.registro_id"
              label="ID Registro"
              type="number"
              prepend-icon="mdi-pound"
              clearable
              outlined
              dense
              @keyup.enter="consultar"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
              v-model="filtros.radicado"
              label="Radicado"
              prepend-icon="mdi-file-document"
              clearable
              outlined
              dense
              @keyup.enter="consultar"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <v-menu
              v-model="menuFechaDesde"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="filtros.fecha_desde"
                  label="Fecha desde"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-on="on"
                  clearable
                  outlined
                  dense
                  @click:clear="consultar"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="filtros.fecha_desde"
                @input="menuFechaDesde = false; consultar()"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3">
            <v-menu
              v-model="menuFechaHasta"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="filtros.fecha_hasta"
                  label="Fecha hasta"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-on="on"
                  clearable
                  outlined
                  dense
                  @click:clear="consultar"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="filtros.fecha_hasta"
                @input="menuFechaHasta = false; consultar()"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3">
            <v-btn color="primary" @click="consultar">
              <v-icon left>search</v-icon>
              Consultar
            </v-btn>
          </v-col>
        </v-row>

        <v-data-table
          :headers="headers"
          :items="auditoria"
          :options.sync="options"
          :server-items-length="total"
          :loading="loading"
          :footer-props="{ 'items-per-page-options': [15, 25, 50] }"
          @click:row="abrirDetalle"
          class="row-pointer"
        >
          <template v-slot:item.evento="{ item }">
            <v-chip
              :color="colorEvento(item.evento)"
              small
              text-color="white"
            >
              {{ item.evento }}
            </v-chip>
          </template>
          <template v-slot:item.valores="{ item }">
            <span class="text-truncate" style="max-width: 300px; display: inline-block;">
              {{ resumenCambios(item) }}
            </span>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialogDetalle" max-width="700px">
      <v-card>
        <v-card-title>
          <v-icon left>history</v-icon>
          Detalle de Auditoría
        </v-card-title>
        <v-card-text v-if="detalleSeleccionado">
          <v-simple-table dense>
            <template v-slot:default>
              <tbody>
                <tr>
                  <td><strong>Evento</strong></td>
                  <td>
                    <v-chip :color="colorEvento(detalleSeleccionado.evento)" small text-color="white">
                      {{ detalleSeleccionado.evento }}
                    </v-chip>
                  </td>
                </tr>
                <tr>
                  <td><strong>Modelo</strong></td>
                  <td>{{ detalleSeleccionado.modelo }}</td>
                </tr>
                <tr>
                  <td><strong>Registro ID</strong></td>
                  <td>{{ detalleSeleccionado.registro_id }}</td>
                </tr>
                <tr>
                  <td><strong>Usuario</strong></td>
                  <td>{{ detalleSeleccionado.usuario ? detalleSeleccionado.usuario.name : 'Sistema' }}</td>
                </tr>
                <tr>
                  <td><strong>Fecha</strong></td>
                  <td>{{ detalleSeleccionado.fecha }}</td>
                </tr>
                <tr>
                  <td><strong>IP</strong></td>
                  <td>{{ detalleSeleccionado.ip }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <v-divider class="my-4"></v-divider>

          <v-row>
            <v-col cols="6">
              <h3 class="subtitle-1 red--text">Valores Anteriores</h3>
              <v-card outlined>
                <v-card-text>
                  <pre v-if="detalleSeleccionado.valores_anteriores">{{ JSON.stringify(detalleSeleccionado.valores_anteriores, null, 2) }}</pre>
                  <span v-else class="grey--text">N/A (registro nuevo)</span>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="6">
              <h3 class="subtitle-1 green--text">Valores Nuevos</h3>
              <v-card outlined>
                <v-card-text>
                  <pre v-if="detalleSeleccionado.valores_nuevos">{{ JSON.stringify(detalleSeleccionado.valores_nuevos, null, 2) }}</pre>
                  <span v-else class="grey--text">N/A (registro eliminado)</span>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogDetalle = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: 'Auditoria',
  data() {
    return {
      auditoria: [],
      total: 0,
      loading: false,
      options: {},
      dialogDetalle: false,
      detalleSeleccionado: null,
      menuFechaDesde: false,
      menuFechaHasta: false,
      filtros: {
        modelo: null,
        evento: null,
        usuario_id: null,
        registro_id: null,
        radicado: null,
        fecha_desde: null,
        fecha_hasta: null,
      },
      usuarios: [],
      modelosOpciones: [
        { text: 'Expediente', value: 'expediente' },
        { text: 'Solicitud Desarchivo', value: 'solicitud' },
      ],
      eventosOpciones: [
        { text: 'Creado', value: 'created' },
        { text: 'Actualizado', value: 'updated' },
        { text: 'Eliminado', value: 'deleted' },
      ],
      headers: [
        { text: 'Fecha', value: 'fecha' },
        { text: 'Usuario', value: 'usuario.name' },
        { text: 'Modelo', value: 'modelo' },
        { text: 'Registro ID', value: 'registro_id' },
        { text: 'Evento', value: 'evento' },
        { text: 'Cambios', value: 'valores', sortable: false },
      ],
    };
  },
  watch: {
    options: {
      handler() {
        this.consultar();
      },
      deep: true,
    },
  },
  created() {
    this.listar_usuarios();
  },
  methods: {
    listar_usuarios() {
      axios
        .get('/api/listar_usuarios')
        .then((response) => {
          this.usuarios = response.data.data || response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    consultar() {
      this.loading = true;
      const { page, itemsPerPage } = this.options;
      let params = {
        page: page || 1,
        per_page: itemsPerPage || 15,
      };
      if (this.filtros.modelo) params.modelo = this.filtros.modelo;
      if (this.filtros.evento) params.evento = this.filtros.evento;
      if (this.filtros.usuario_id) params.usuario_id = this.filtros.usuario_id;
      if (this.filtros.registro_id) params.registro_id = this.filtros.registro_id;
      if (this.filtros.radicado) params.radicado = this.filtros.radicado;
      if (this.filtros.fecha_desde) params.fecha_desde = this.filtros.fecha_desde;
      if (this.filtros.fecha_hasta) params.fecha_hasta = this.filtros.fecha_hasta;

      axios
        .get('/api/auditoria', { params })
        .then((response) => {
          this.auditoria = response.data.data;
          this.total = response.data.total;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.$alertify.error('Error al consultar auditoría');
        });
    },
    abrirDetalle(item) {
      this.detalleSeleccionado = item;
      this.dialogDetalle = true;
    },
    colorEvento(evento) {
      switch (evento) {
        case 'created':
          return 'green';
        case 'updated':
          return 'orange';
        case 'deleted':
          return 'red';
        default:
          return 'grey';
      }
    },
    resumenCambios(item) {
      if (item.evento === 'created' && item.valores_nuevos) {
        return 'Nuevo registro creado';
      }
      if (item.evento === 'deleted') {
        return 'Registro eliminado';
      }
      if (item.valores_anteriores) {
        return Object.keys(item.valores_anteriores).join(', ');
      }
      return '';
    },
  },
};
</script>

<style scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>
